






































































































import BaseFilter from '@/components/Filter/BaseFilter';
import { Component, PropSync } from 'vue-property-decorator';
import { PartnerConnectionFilter } from '@/store/settings/partners_connections/types';
import { SelectWings, ToggleWings, InputWings } from "wings-ui-components";
import { Action, Getter } from 'vuex-class';
import { notifyError } from '@/utils/notify-helper';

@Component({ components: { SelectWings, ToggleWings, InputWings } })
export default class PartnersConnectionsFilter extends BaseFilter<PartnerConnectionFilter> {

  @PropSync('show') is_show!: boolean;

  @Getter("transports") transportsList: any;

  @Action("getPartners") actionGetPartners: any;
  @Action("getAccounts") actionGetAccounts: any;
  @Action("getTransports") actionGetTransports: any;
  @Action("getPartnersConnections") actionGetPartnersConnections: any;
  @Action("exportPartnersConnections") actionExportPartnersConnections: any;
  @Action("actionLog") actionLog: any;

  partnersList: any = []
  accountsList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners(filter);
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getAccountsList(filter: any) {
    const items = await this.actionGetAccounts({...filter, protocol: 'SMPP'});
    this.accountsList = (filter?.page_number > 1) ? this.accountsList.concat(items) : items
  }

  async created() {
    this.actionGetTransports();
    this.filtered();
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    if (this.filter.broker_account) this.accountsList = await this.actionGetAccounts({login: this.filter.broker_account});
  }

  defaultFilter(): PartnerConnectionFilter {
    return {
      partner: undefined,
      broker_account: undefined,
      connection_type: undefined,
      protocol: undefined,
      transport: undefined,
      status_duration: undefined,
    }
  }

  get brokerAccountsList() {
    return this.accountsList.filter( (val: any) =>
      val.protocol.toLowerCase() === 'smpp'
    );
  }

  get transportsForOriginatorsList() {
    return this.transportsList.filter((val: any) =>
      val.name.toLowerCase() === 'sms' ||
      val.name.toLowerCase() === 'call'
    );
  }

  export() {
    this.actionExportPartnersConnections(this.filter)
      .catch( (error: any) => notifyError(error));
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Client's connection",
        addititional_info: this.filter
      };
      await this.actionGetPartnersConnections(this.filter);
      await this.actionLog(this.logObject);
    } catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }
};

